module.exports = __webpack_public_path__ + "assets/4133092ba3f16610afa3245bd3a457a7.png";